// Hooks
import useTranslate from "hooks/useTranslate";

// Types
import { SupportItemModel } from "../../../types/info";

import "./styles.sass";

type SupportItemProps = {
  support: SupportItemModel;
};

const SupportItem = (props: SupportItemProps) => {
  const t = useTranslate();
  // eslint-disable-next-line react/destructuring-assignment
  const { image, title, description, notice } = props.support;

  return (
    <div className="SupportItem">
      <div className="SupportItem-key">
        <div className="SupportItem-key__logo">{image}</div>
        <span className="SupportItem-key__title">{t(title)}</span>
      </div>
      <div>
        <span className="SupportItem__description">{t(description)}</span>
        <span className="SupportItem__notice">{t(notice)}</span>
      </div>
    </div>
  );
};

export default SupportItem;
